export default {
  messageId: 'proxy-login',
  bannerTag: 'PROXY_LOGIN',
  descriptionTag: 'PROXY_LOGIN_DESCRIPTION',
  type: 'account',
  additionalAttributes: [],
};
